import React, { useEffect, useState } from 'react';
import LeadingPage from './index';
import { IComponentGuide } from '../../component';
import imageUtil from '../../utils/image';
import { isIphoneX } from '../../utils/util';
import { RouteComponentProps, withRouter } from 'react-router';
import ComponentLink from '../ComponentLink';

interface IAllForLeadingPage extends IComponentGuide {

}

const AllForGuide = function (props: IAllForLeadingPage) {
  const {
    image,
    autoPlay,
    showBar,
    duration,
    link,
    barColor,
    opacity
  } = props;
  const { gallery, pageDetail } = window;

  const toNextPage = () => {
    ComponentLink.to(link);
  };

  useEffect(() => {
    let timer: number;
    // 自动跳过的处理
    if (autoPlay && duration) {
      timer = window.setTimeout(() => {
        console.log('到时间了，跳咯', link);
        toNextPage();
      }, duration);
    }
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <LeadingPage
      autoPlay={autoPlay}
      duration={duration}
      // avatars={visited || []}
      bg={imageUtil.style(image, isIphoneX() ? 'background_ipx' : 'background')}
      skip={toNextPage}
      showBar={showBar}
      barColor={barColor}
      opacity={opacity}
    />
  );
};
export default AllForGuide;
